import { FormControl, InputLabel } from '@material-ui/core';
import React from 'react';

import { currencyFormat } from 'utils/currencyFormat';
import Budget from 'entities/budget/model';
import { BudgetTotals } from 'containers/DonationRulesListPage/utils';

interface Props {
  budget: Budget;
  budgetTotals: BudgetTotals;
  budgetInactive: boolean;
}

export const DonationGivingRulesDonationCreditSummary = ({
  budget,
  budgetTotals,
  budgetInactive,
}: Props) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 15,
      opacity: budgetInactive ? 0.5 : 1,
    }}
  >
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Credit Used</InputLabel>
      </FormControl>
      <div>{currencyFormat(budgetTotals.totalCreditSpent, budget.get('currencyCode'))}</div>
    </div>
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Spendable Credit</InputLabel>
      </FormControl>
      <div>{currencyFormat(budgetTotals.totalCreditSpendable, budget.get('currencyCode'))}</div>
    </div>
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Credit Expired</InputLabel>
      </FormControl>
      <div>{currencyFormat(budgetTotals.totalCreditExpired, budget.get('currencyCode'))}</div>
    </div>
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Credit Issued</InputLabel>
      </FormControl>
      <div>{currencyFormat(budgetTotals.totalCredited, budget.get('currencyCode'))}</div>
    </div>
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Credits Issued</InputLabel>
      </FormControl>
      <div>{budgetTotals.creditingTransactionsCount}</div>
    </div>
  </div>
);

export default DonationGivingRulesDonationCreditSummary;
